import React from 'react';

import { A11yWrapper } from 'components/a11y-wrapper';
import Currency from 'components/currency';
import { CurrencyLineSkeleton } from 'pages/cart/currency-line-skeleton';
import { t } from 'state/intl/translations';
import { getDesignToken } from 'styles/constants';

import { useCheckoutContext } from '../../hooks/use-checkout-context';

import { GrandTotalLabel, Total, TotalsRow } from './styled';

const GrandTotalRow = TotalsRow.withConfig({
  marginTop: '$4',
});

interface GrandTotalProps {
  isLoading?: boolean;
}

const GrandTotal: React.FC<React.PropsWithChildren<GrandTotalProps>> = ({ isLoading }) => {
  const { totals } = useCheckoutContext();
  // This makes sure that the grand total is always a number and > 0.
  const grandTotal = totals && totals?.grandTotal > 0 ? totals.grandTotal : 0;

  if (isLoading) {
    return (
      <GrandTotalRow>
        <CurrencyLineSkeleton />
      </GrandTotalRow>
    );
  }

  return (
    <GrandTotalRow>
      <>
        <A11yWrapper>
          <GrandTotalLabel>{t('total')}</GrandTotalLabel>
        </A11yWrapper>
        <Total>
          <Currency
            testID="grand-total"
            amount={grandTotal > 0 ? grandTotal : 0}
            isBold
            textProps={{
              fontSize: 'md',
              color: getDesignToken('text-default'),
              margin: 0,
              flexGrow: 0,
            }}
          />
        </Total>
      </>
    </GrandTotalRow>
  );
};

export default GrandTotal;
